import(/* webpackMode: "eager", webpackExports: ["Table","TableFooter","TableRow","TableCell"] */ "/app/src/components/ui/table.tsx");
